import { Car, DvlaCarDetails } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

// export type Car = {
//     id: number;
//     make: string;
//     model: string;
//     colour: string;
//     reg: string;
//     createdAt: string;
//     lastUpdated: string;
//     createdBy: string;
//     lastUpdatedBy: string;
//     owner: string;
//     ownerType: 'student' | 'staff' | 'visitor';
//     vehicleType: 'car' | 'bike';
// }

export async function getCars() {
    try {
        const response = await portalApi.get<Car[]>("/cars/all");
        return response.data;
    } catch (error) {
        console.error("Error fetching cars:", error);
        throw error;
    }
}

export async function getCar(carId: string, ownerType: 'student' | 'staff' | 'visitor') {
    try {
        const response = await portalApi.get<Car>(`/cars/${carId}`, {
            params: {
                ownerType
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching car:", error);
        throw error;
    }
}

export async function getPossibleCars(searchQuery: string) {
    try {
        const response = await portalApi.get<Car[]>(`/cars/search`, {
            params: {
                q: searchQuery
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error fetching car:", error);
        throw error;
    }
}

// export type DvlaCar = {
//     registrationNumber: string;
//     taxStatus?: "Not Taxed for on Road Use" | "SORN" | "Taxed" | "Untaxed";
//     taxDueDate?: string;
//     artEndDate?: string;
//     motStatus?: "No details held by DVLA" | "No results returned" | "Not valid" | "Valid";
//     motExpiryDate?: string;
//     make?: string;
//     monthOfFirstDvlaRegistration?: string;
//     monthOfFirstRegistration?: string;
//     yearOfManufacture?: number;
//     engineCapacity?: number;
//     co2Emissions?: number;
//     fuelType?: string;
//     markedForExport?: boolean;
//     colour?: string;
//     typeApproval?: string;
//     wheelplan?: string;
//     revenueWeight?: number;
//     realDrivingEmissions?: string;
//     dateOfLastV5CIssued?: string;
//     euroStatus?: string;
//     automatedVehicle?: boolean;
// };

export async function checkCarWithDVLA(reg: string) {
    try {
        const response = await portalApi.get<DvlaCarDetails>(`/cars/check/${reg}`);
        return response.data;
    } catch (error) {
        console.error("Error checking car with DVLA:", error);
        throw error;
    }
}
